const defaultOptions = {
    maxLength: 255,
    errorMessage: 'Must be less than {{maxLength}} characters',
};
const validateInput = (input = '', options = defaultOptions) => {
    const opts = Object.assign(Object.assign({}, defaultOptions), options);
    const stringInput = input || '';
    return stringInput.length > opts.maxLength
        ? opts.errorMessage.replace(/{{maxLength}}/g, opts.maxLength.toString())
        : undefined;
};
export const validateMaxLength = (input) => validateInput(input);
export const getValidateMaxLengthFn = (options) => {
    return (input) => validateInput(input, options);
};
